import { nanoid } from 'nanoid';

const SESSION_ID_KEY = 'web-chat-session-id';

/**
 * Get or create session ID
 * Matches backend session ID format (32 characters nanoid)
 */
export function getOrCreateSessionId(): string {
  // Check localStorage
  let sessionId = localStorage.getItem(SESSION_ID_KEY);

  // Validate format (should be 16-64 chars as per backend)
  if (!sessionId || sessionId.length < 16 || sessionId.length > 64) {
    sessionId = nanoid(32);
    localStorage.setItem(SESSION_ID_KEY, sessionId);
  }

  return sessionId;
}

/**
 * Set session ID
 */
export function setSessionId(sessionId: string): void {
  localStorage.setItem(SESSION_ID_KEY, sessionId);
}

/**
 * Clear session ID
 */
export function clearSessionId(): void {
  localStorage.removeItem(SESSION_ID_KEY);
}

/**
 * Get session ID without creating a new one
 */
export function getSessionId(): string | null {
  return localStorage.getItem(SESSION_ID_KEY);
}
